import { render, staticRenderFns } from "./service-overnight.vue?vue&type=template&id=f4b477d2&"
import script from "./service-overnight.vue?vue&type=script&lang=js&"
export * from "./service-overnight.vue?vue&type=script&lang=js&"
import style0 from "./service-overnight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports